import roundedLogo from '../../assets/images/img_blue_fish.png';
import './assets/app_download_page.css';
import React from 'react';

import appStoreIcon from '../common/assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import googlePlayIcon from '../common/assets/images/google-play-badge.png';

export default function AppDownloadLinks() {
  return (
    <div className='app_download_page gRegular'>
      <div
        className={'app_download__card bg-white txt-center pd-20 br8'}
        style={{ maxWidth: 'min(95%, 40rem)' }}
      >
        <div class='app_download__icon'>
          <img width={120} src={roundedLogo} alt='swimbooker logo' />
        </div>
        <div>
          <h2 className={'gSemiBold fs-30'}>swimbooker</h2>
          <a className='sb-blue-700 fs-16' href='https://www.swimbooker.com'>
            https://www.swimbooker.com
          </a>
          <p className='mg-top-20 mg-bottom-20 fs-16'>
            Book fishing at over 400+ lakes around the UK &amp; abroad with no
            additional booking fees! Download our mobile app (iOS/Android) to
            upload your catch reports, favourite lakes and much more!
          </p>
          <div className='display-flex-row gap-1r justify-center w-full mg-top-10 mg-bottom-15 flex-wrap'>
            <a href={'https://apps.apple.com/gb/app/swimbooker/id1586855906'}>
              <img
                width={200}
                height={61}
                src={appStoreIcon}
                alt={'Download on the App Store'}
              />
            </a>
            <a href='https://play.google.com/store/apps/details?id=com.app.swimbookerapp'>
              <img
                width={200}
                src={googlePlayIcon}
                alt='Get it on Google Play'
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
